import { Form } from "react-bootstrap";
import { CrudInputModel } from "./crudInputModel";
import { RequiredAsterisks } from "../../Asterisks/requiredAsterisks";

export const CrudTextInput = ({
  validationSchema,
  form,
  name,
  label,
  disabled,
  t,
  required,
}: CrudInputModel) => {
  return (
    <form.Field
      key={name}
      name={name}
      validators={{
        onSubmit: validationSchema,
      }}
    >
      {(field) => {
        return (
          <Form.Group className="mb-3">
            <Form.Label>
              {label} {required && <RequiredAsterisks />}
            </Form.Label>
            <Form.Control
              id={field.name}
              key={field.name}
              name={field.name}
              value={field.state.value as string}
              onBlur={field.handleBlur}
              onChange={(e) => field.handleChange(e.target.value)}
              isInvalid={field.state.meta.errors.length > 0}
              disabled={disabled}
            />
            {field.state.meta.errors && field.state.meta.errors[0] ? (
              <Form.Control.Feedback type="invalid">
                {t(field.state.meta.errors[0])}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
        );
      }}
    </form.Field>
  );
};
